export default __webpack_public_path__ + "static/media/Class-9-CBSE-Kannada.df430247.pdf";